import "./Header.scss";
import { Link } from "react-router-dom";
import { ArrowRight } from "react-bootstrap-icons";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const Header = () => {
  // const navigate = useNavigate();
  // const jwtToken = useSelector((state) => state.loginChecker.jwtToken);
  const manualType = useSelector((state) => state.manualTypeChecker.manualType);

  // const switchManualType = () => {
  //   // navigate(manualType == "kt" ? "g" : "kt");
  //   console.log(manualType);
  //   console.log(manualType == "kt" ? "/g" : "/kt");
  //   console.log("navigate to another manual type");
  // };

  return (
    <div id="header-area">
      <div className="header-logo">
        <Link className="logo-image" to="category-edit">
          <img
            id="logo-image-tag"
            src="/assets/KT_CLOUD_LOGO_WHITE.png"
            alt="로고"
          />
        </Link>
        {manualType == "kt" ? (
          <span className="logo-text-kt">매뉴얼</span>
        ) : (
          <span className="logo-text-g">공공 클라우드 매뉴얼</span>
        )}
      </div>
      <div className="gnb"></div>
    </div>
  );
};

export default Header;
